import { useState, useRef } from "react";

// Autocomplétion d'adresse via la Base Adresse Nationale (api-adresse.data.gouv.fr,
// externe, sans auth). onPick renvoie {rue, cp, ville} DÉCOUPLÉS (pas une chaîne concaténée)
// → le parent gère 3 champs. SOCLE partagé (CC-DEV1-31) : extrait d'OmvCeeEditor pour être
// réutilisé par le wizard TEF + OMV (source unique, pas de divergence).
export default function BanAddressInput({ value, onChange, onPick, placeholder, testId }) {
  const [sugg, setSugg] = useState([]);
  const [open, setOpen] = useState(false);
  const tRef = useRef();
  const query = (q) => {
    clearTimeout(tRef.current);
    if (!q || q.trim().length < 3) { setSugg([]); setOpen(false); return; }
    tRef.current = setTimeout(async () => {
      try {
        const r = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(q)}&limit=5`);
        if (r.ok) { const d = await r.json(); setSugg(d.features || []); setOpen(true); }
      } catch { /* hors-ligne : saisie manuelle */ }
    }, 350);
  };
  return (
    <div className="relative">
      <input
        value={value ?? ""}
        placeholder={placeholder || "Commencez à taper l'adresse…"}
        onChange={(e) => { onChange(e.target.value); query(e.target.value); }}
        onBlur={() => setTimeout(() => setOpen(false), 180)}
        data-testid={testId}
        className="w-full rounded px-3 py-2 text-sm"
        style={{ background: "var(--oh-bg-base)", border: "1px solid var(--oh-border)", color: "var(--oh-text)" }}
      />
      {open && sugg.length > 0 && (
        <div className="absolute z-50 left-0 right-0 mt-1 rounded-md shadow-lg max-h-56 overflow-y-auto"
          style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
          {sugg.map((f, i) => {
            const p = f.properties || {};
            return (
              <button key={i} type="button"
                className="w-full text-left px-3 py-2 text-sm hover:opacity-80"
                style={{ color: "var(--oh-text)" }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  const rue = p.name || [p.housenumber, p.street].filter(Boolean).join(" ") || (p.label || "");
                  onPick({ rue, cp: p.postcode || "", ville: p.city || "" });
                  setOpen(false); setSugg([]);
                }}>
                {p.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
